import { EntityInput } from "@dzambalaorg/mui-inputs-entity";
import { SearchWithFilters } from "@dzambalaorg/mui-form-search";

export interface IReferralTreeMerchantSearchDto {
  merchantIds: Array<number>;
}

interface IReferralTreeMerchantSearchFormProps {
  initialValues: IReferralTreeMerchantSearchDto;
}

export const ReferralTreeMerchantSearchForm = (props: IReferralTreeMerchantSearchFormProps) => {
  const { initialValues } = props;

  const { merchantIds } = initialValues;
  const fixedValues = { merchantIds };

  return (
    <SearchWithFilters initialValues={fixedValues}>
      <EntityInput name="merchantIds" multiple controller="referral/tree" />
    </SearchWithFilters>
  );
};
